import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/baldr/baldr/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/home/runner/work/baldr/baldr/src/providers/client-providers.tsx");
